import { Module } from "wrapper6";
import Glide from '@glidejs/glide'
import { ArrowControls, ArrowDisabler, ArrowResizer } from '../utils/_glide-plugins';

export default class Slider extends Module {
  ready() {
    const OPTIONS = {
      type: 'slider',
      rewind: false,
      bound: true,
      gap: 32,
      perView: 3,
      arrowClasses: {
        'back': 'slider-arrow--left',
        'next': 'slider-arrow--right',
        'disabled': 'slider-arrow--disabled'
      },
      breakpoints: {
        900: {
          perView: 2
        },
        580: {
          perView: 1
        }
      }
    }

    if (document.querySelector('.mtt-slider .glide')) {
      new Glide('.mtt-slider .glide', OPTIONS).mount({ ArrowControls, ArrowDisabler, ArrowResizer });
    }
  }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_slider.js